export const GROUP_TYPES = {
  operations: "operations",
  payor_relations: "payor_relations",
  inside_sales: "inside_sales",
  optum_enrollment: "optum_enrollment",
};
